
export function isMobile(checkIpad = false) {

    console.log('isMobile called');

    if ((window.location !== window.parent.location) || checkIpad) {
        const toMatch = [
            /Android/i,
            /webOS/i,
            /iPhone/i,
            /iPad/i,
            /iPod/i,
            /BlackBerry/i,
            /Windows Phone/i
        ];

        let check = toMatch.some((toMatchItem) => {
            return navigator.userAgent.match(toMatchItem);
        });

        if(check) {
            return true
        }

        if (navigator.maxTouchPoints === 0) {
            return false;
        }
        check = navigator.maxTouchPoints > 0;

        return check
    } else if(window.innerWidth >= 768) {
        return false
    }

    return true
}
